import { render, staticRenderFns } from "./TestimonyInterviewForm.vue?vue&type=template&id=71603f57&"
import script from "./TestimonyInterviewForm.vue?vue&type=script&lang=js&"
export * from "./TestimonyInterviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports